export interface IMomentum {
  date: string;
  value: number;
  period: MomentumPeriod;
}


export enum FactorValueType {
  Volatility = 1,

  Momentum10Days = 5,
  Momentum5Days = 6,

  TradingVolumesRate = 15,

  GoogleTrends = 10,
}

export enum MomentumPeriod {
  Momentum10Days = FactorValueType.Momentum10Days,
  Momentum5Days = FactorValueType.Momentum5Days,
}
